/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

//////////////////////////////////
// Trading Accounts permissions //
//////////////////////////////////
// Create Permissions //
////////////////////////
export const create: RoleList = [
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  Roles.MANAGER,
  Roles.ASSET_MANAGER,
];

// Create Permissions > New account
export const createNewAccount: RoleList = [...create];

export const canBatchImport: RoleList = [Roles.SYSTEM_ADMIN];

// Create Permissions > Export an account's asset data
export const createExportData: RoleList = [
  ...create,
  Roles.ACCOUNT_MANAGER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// Create Permissions > Custom fields for assets
export const createCustomFields: RoleList = [...create];

//////////////////////
// Read Permissions //
//////////////////////
export const read: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const update: RoleList = [
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  Roles.MANAGER,
  Roles.ASSET_MANAGER,
];

// Update Permissions > Edit trading account
export const updateEditAccount: RoleList = [...update];

// Update Permissions > Account assigned users
export const updateAssignedUsers: RoleList = [...update];

// Update Permissions > Disable / Enable an account
export const updateDisableEnableAccount: RoleList = [...update];

// Update Permissions > Archive / Unarchive an account
export const updateArchiveUnarchiveAccount: RoleList = [...update];

////////////////////////
// Delete Permissions //
////////////////////////
export const del: RoleList = [Roles.ACCOUNT_ADMIN, Roles.SYSTEM_ADMIN];

////////////////////////////////////////
// Trading Accounts Users permissions //
////////////////////////////////////////
// Create Permissions //
////////////////////////

// Create Permissions > Invite user to a trading account (new or existing)
export const createInviteUser: RoleList = [...create];

//////////////////////
// Read Permissions //
//////////////////////

// Read Permissions > Read for user
export const readUser: RoleList = [...read];

// Read Permissions > View as user
export const readViewAsUser: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// Read Permissions > Login as user
export const readLoginAsUser: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const updateUser: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
];

// Update Permissions > Exisiting user role
export const updateExistingUserRole: RoleList = [...updateUser];

// Update Permissions > Approve account access request
export const updateApproveAccessRequest: RoleList = [...updateUser];

// Update Permissions > Decline account access request
export const updateDeclineAccessRequest: RoleList = [...updateUser];

// Update Permissions > Accounts assigned to user
export const updateAssignedToUser: RoleList = [...updateUser];

// Update Permissions > Revoke account access from a user
export const updateRevokeAccess: RoleList = [...updateUser];

// Update Permissions > Assign user to locations
export const updateAssignToLocation: RoleList = [...updateUser];

// Update Permissions > Disable / Enable user access to trading account
export const updateDisableEnableAccess: RoleList = [...updateUser];

////////////////////////////////////////////
// Trading Accounts Locations permissions //
////////////////////////////////////////////
// Create Permissions //
////////////////////////

// Create Permissions > Invite user to a trading account (new or existing)
export const createNewLocation: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
];

//////////////////////
// Read Permissions //
//////////////////////

// Read Permissions > Read locations
export const readLocations: RoleList = [...read];

////////////////////////
// Update Permissions //
////////////////////////
export const updateLocation: RoleList = [Roles.ACCOUNT_ADMIN, Roles.SYSTEM_ADMIN];

// Update Permissions > Edit location / Audit Location
export const updateEditLocation: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.USER,
  Roles.PURCHASER,
  ...updateLocation,
];

// Edit Location: Accounts > Sites > Start Audit
export const auditLocation: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.USER,
  Roles.PURCHASER,
  ...updateLocation,
];

// Edit Location: Accounts > Sites > Mark/Unmark as default
export const editLocationDefault: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.USER,
  Roles.PURCHASER,
  ...updateLocation,
];

// Edit Location: Accounts > Manage Locations
export const editLocation: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.PURCHASER,
  ...updateLocation,
];

export const updateEditCountry: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  ...updateLocation,
];

// Update Permissions > Assign users to location
export const updateAssignUsersToLocation: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  ...updateLocation,
];

// Update Permissions > Archive / Unarchive location
export const updateArchiveUnarchiveLocation: RoleList = [...updateLocation];

// Update Permissions > Add account no.
export const addAccountNo: RoleList = [Roles.SYSTEM_ADMIN, Roles.ASSET_MANAGER];

export const addAssetRequestDetails: RoleList = [Roles.SYSTEM_ADMIN];

export const viewAssetRequestForm: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.USER,
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
];

export const viewLicenseRequestForm: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.USER,
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
];

// Update Permissions > Edit Region
export const updateRegion: RoleList = [Roles.SYSTEM_ADMIN, Roles.ASSET_MANAGER];

export const viewRegion: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
];

// Upload Documents and Resources
export const uploadDocumentsOrResources: RoleList = [
  Roles.ACCOUNT_MANAGER,
  Roles.SYSTEM_ADMIN,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
];

//////////////////////////////////////////
// Perform Actions on Users Permissions //
//////////////////////////////////////////

export const actionsOnAccountUsers = {
  // Perform Actions to > User
  [Roles.USER]: [
    Roles.USER,
    Roles.VIEW_ONLY,
    Roles.PURCHASER,
    Roles.MANAGER,
    Roles.ACCOUNT_ADMIN,
    Roles.ACCOUNT_MANAGER,
    Roles.ASSET_MANAGER,
    Roles.BUSINESS_VIEW_ONLY,
    Roles.SYSTEM_ADMIN,
    Roles.SYSTEM_ADMIN_REGIONAL,
  ],
  // Perform Actions to > Customer Executive
  [Roles.VIEW_ONLY]: [
    Roles.VIEW_ONLY,
    Roles.PURCHASER,
    Roles.MANAGER,
    Roles.ACCOUNT_ADMIN,
    Roles.ACCOUNT_MANAGER,
    Roles.ASSET_MANAGER,
    Roles.BUSINESS_VIEW_ONLY,
    Roles.SYSTEM_ADMIN,
    Roles.SYSTEM_ADMIN_REGIONAL,
  ],
  // Perform Actions to > Purchaser
  [Roles.PURCHASER]: [
    Roles.PURCHASER,
    Roles.MANAGER,
    Roles.ACCOUNT_ADMIN,
    Roles.ACCOUNT_MANAGER,
    Roles.ASSET_MANAGER,
    Roles.BUSINESS_VIEW_ONLY,
    Roles.SYSTEM_ADMIN,
    Roles.SYSTEM_ADMIN_REGIONAL,
  ],
  // Perform Actions to > Manager
  [Roles.MANAGER]: [
    Roles.MANAGER,
    Roles.ACCOUNT_ADMIN,
    Roles.ACCOUNT_MANAGER,
    Roles.ASSET_MANAGER,
    Roles.BUSINESS_VIEW_ONLY,
    Roles.SYSTEM_ADMIN,
    Roles.SYSTEM_ADMIN_REGIONAL,
  ],
  // Perform Actions to > Account Admin
  [Roles.ACCOUNT_ADMIN]: [
    Roles.ACCOUNT_ADMIN,
    Roles.ACCOUNT_MANAGER,
    Roles.ASSET_MANAGER,
    Roles.BUSINESS_VIEW_ONLY,
    Roles.SYSTEM_ADMIN,
    Roles.SYSTEM_ADMIN_REGIONAL,
  ],
};
